[
  {
    "id": "TB-E8-L305-001",
    "module": "Taalbegrip",
    "difficulty": 305,
    "question": "Wat betekent 'legitiem'?",
    "options": [
      "Wettig / geldig",
      "Nep",
      "Leeg",
      "Laat"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-LEGITIEM",
    "explanation": "Legitiem betekent dat het mag volgens de wet of regels.",
    "distractorExplanations": {
      "1": "Illegitiem.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-E8-L305-002",
    "module": "Taalbegrip",
    "difficulty": 305,
    "question": "Wat is 'retorische vraag'?",
    "options": [
      "Vraag waarop je geen antwoord verwacht",
      "Moeilijke vraag",
      "Vraag in het Latijn",
      "Domme vraag"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "stijl",
    "subSkill": "stijlfiguren",
    "familyId": "TB-RETORISCH",
    "explanation": "Een retorische vraag stel je om een punt te maken, niet voor een antwoord.",
    "distractorExplanations": {
      "1": "Niet per se.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-E8-L305-003",
    "module": "Taalbegrip",
    "difficulty": 305,
    "question": "Wat betekent 'simultaan'?",
    "options": [
      "Gelijktijdig",
      "Na elkaar",
      "Alleen",
      "Simpel"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-SIMULTAAN",
    "explanation": "Simultaan betekent dat dingen op hetzelfde moment gebeuren.",
    "distractorExplanations": {
      "1": "Volgtijdelijk.",
      "2": "Solo.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-E8-L305-004",
    "module": "Taalbegrip",
    "difficulty": 305,
    "question": "Wat is een 'neologisme'?",
    "options": [
      "Nieuw woord",
      "Oud woord",
      "Fout woord",
      "Moeilijk woord"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "taalbegrippen",
    "familyId": "TB-NEOLOGISME",
    "explanation": "Neo = nieuw. Een neologisme is een nieuw bedacht woord.",
    "distractorExplanations": {
      "1": "Archaïsme.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-E8-L305-005",
    "module": "Taalbegrip",
    "difficulty": 305,
    "question": "Wat betekent 'authentiek'?",
    "options": [
      "Echt / oorspronkelijk",
      "Nep",
      "Automatisch",
      "Oud"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-AUTHENTIEK",
    "explanation": "Authentiek betekent dat het echt is, niet nagemaakt.",
    "distractorExplanations": {
      "1": "Vervalsing.",
      "2": "Lijkt erop.",
      "3": "Kan, maar hoeft niet."
    }
  }
]